import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableHead,
  Tooltip,
} from "@mui/material";
import {
  OutlinedIconFab,
  StyledTableCellHistory,
  StyledTableContainer,
  StyledTableRowHistory,
} from "../StyledComponents";
import Icon from "../Utils/Icons";
import { formatDurationTextForDisplay } from "../HistoriesData/durationUtils";
import { getDefaultFieldLayout } from "../config/defaults/fieldLayoutUtils";

const DEFAULT_COLUMN_RENDER = {
  condition: (row) => (
    <>
      {row.condition}
      {row?.source === "voice" && !row.id && (
        <Tooltip title="Machine-interpreted text — please verify before confirming">
          <span className="missing-id-warning">⚠️</span>
        </Tooltip>
      )}
    </>
  ),
  clinical_status_description: (row) =>
    row.clinical_status_description ? row.clinical_status_description : "-",
  duration: (row) =>
    row.duration
      ? row.durationType
        ? formatDurationTextForDisplay(`${row.duration} ${row.durationType}`)
        : formatDurationTextForDisplay(row.duration)
      : "-",
  clinical_note: (row) =>
    row.clinical_note?.length > 0 ? row.clinical_note : "-",
};

export const ChiefComplaintTable = ({
  data,
  activeSection,
  handleEditRow = () => { },
  handleDeleteRow = () => { },
  fieldLayout: fieldLayoutProp,
}) => {
  const fieldLayout =
    fieldLayoutProp || getDefaultFieldLayout("chiefComplaintRow");

  if (!data || data.length === 0) return null;

  const columns = fieldLayout.tableColumns || [];

  return (
    <>
      {data.length > 0 && (
        <Grid item xs={12}>
          <StyledTableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }}>
              <TableHead>
                <StyledTableRowHistory>
                  {columns.map((column) => (
                    <StyledTableCellHistory key={column.key}>
                      {column.label}
                    </StyledTableCellHistory>
                  ))}
                  {activeSection && (
                    <StyledTableCellHistory>Actions</StyledTableCellHistory>
                  )}
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {data.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    {columns.map((column) => (
                      <StyledTableCellHistory key={column.key}>
                        {(DEFAULT_COLUMN_RENDER[column.key] ||
                          ((r) => r?.[column.key]))(row)}
                      </StyledTableCellHistory>
                    ))}
                    {activeSection && (
                      <StyledTableCellHistory>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <OutlinedIconFab
                            onClick={() => handleEditRow(rowIndex)}
                            sx={{ marginRight: 1 }}
                          >
                            <Icon name="editInTable" size={32} />
                          </OutlinedIconFab>
                          <OutlinedIconFab
                            onClick={() => handleDeleteRow(rowIndex)}
                          >
                            <Icon name="deleteInTable" size={32} />
                          </OutlinedIconFab>
                        </Box>
                      </StyledTableCellHistory>
                    )}
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};
